// client/src/coms/views/canvas_parts/canvas_room_view_parts/constants.js
export const BUCKET_FILL_TOLERANCE = 32;
export const BUCKET_ALPHA_EMPTY_THRESHOLD = 8;
export const BUCKET_EDGE_BLEND_ALPHA_THRESHOLD = 96;
export const BUCKET_EDGE_BLEND_PASSES = 2;
export const MAX_LAYER_HISTORY = 500;
export const MAX_DOCUMENT_HISTORY = 500;
export const MIN_ZOOM = 0.1;
export const MAX_ZOOM = 128;
export const ZOOM_STEP = 0.25;
export const TOOL_OPACITY_DEFAULT = 1;
export const TOOL_OPACITY_MIN = 0.01;
export const TOOLBAR_OPEN_KEY = 'canvas-tools-toolbar-open';
